<div class="container">
    <div class="row">
        <div class="col">
            <div class="jumbotron w-100">
                <h1 class="text-capitalize">Archivio</h1>
                <p>Ci sono {{ get().length }} documenti caricati nel sistema</p>
                <button type="button" class="btn btn-primary" (click)="handleModal(undefined, 'create')">Aggiungi</button>
            </div>
        </div>
    </div>

    <div class="row mb-3" id="accordion">
        <div class="col">
            <div class="card">
                <div class="card-header" id="filters_header">
                    <h5 class="mb-0">
                        <button class="btn btn-primary" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne" (click)="filter_expanded = !filter_expanded">
                            Mostra filtri<i class="fas ml-3" [ngClass]="{'fa-chevron-down': !filter_expanded, 'fa-chevron-up': !!filter_expanded}"></i>
                        </button>
                    </h5>
                </div>

                <div id="collapseOne" class="collapse" aria-labelledby="filters_header" data-parent="#accordion">
                    <div class="card-body pb-0">
                        <div class="row mb-3">
                            <div class="col-12 col-md-4">
                                <label for="type">Seleziona gruppo</label>
                                <select name="group_select" id="group_select" class="form-control" [(ngModel)]="filter.group">
                                    <option value="">-</option>
                                    <option [value]="group.id" *ngFor="let group of window.usher.get()?.public_configuration?.groups; index as i">{{ group.name }}</option>
                                </select>
                            </div>
                            <div class="col-12 col-md-4">
                                <label for="type">Seleziona cliente</label>
                                <select name="client_select" id="client_select" class="form-control" [(ngModel)]="filter.client">
                                    <option value="">-</option>
                                    <option [value]="window.usher.getPublicToken()">{{ window.usher.getPublicConfiguration()?.nome }}</option>
                                    <option [value]="user.public_token" *ngFor="let user of getUsers(undefined, 'cliente'); index as i">{{ user.public_configuration?.nome }}</option>
                                </select>
                            </div>
                            <div class="col-12 col-md-4">
                                <label for="type">Seleziona dipendente</label>
                                <select name="worker_select" id="worker_select" class="form-control" [(ngModel)]="filter.worker">
                                    <option value="">-</option>
                                    <option [value]="user.public_token" *ngFor="let user of getUsers(undefined, 'dipendente'); index as i">{{ user.public_configuration?.nome }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-12 col-md-4">
                                <label>Da</label>
                                <span class="form-control cursor-pointer background-hover" (click)="datepicker_filter_from.show()">{{ window.flowup.utils.getDateTime(filter.from) }}</span>
                            </div>
                            <div class="col-12 col-md-4">
                                <label>A</label>
                                <span class="form-control cursor-pointer background-hover" (click)="datepicker_filter_to.show()">{{ window.flowup.utils.getDateTime(filter.to) }}</span>
                            </div>
                            <div class="col-12 col-md-4">
                                <label>Filtro di ricerca</label>
                                <input type="text" class="form-control" id="filter_text" name="filter_text" [(ngModel)]="filter.text">
                            </div>
                        </div>
                        <div class="row"><div class="col-12"><hr></div></div>
                        <div class="row mb-3">
                            <div class="col-md-6 col-sm-12">
                                <div class="form-group">
                                    <label for="archivio_ordinamento">Ordinamento</label>
                                    <select [(ngModel)]="filter.ordinamento" id="archivio_ordinamento" name="archivio_ordinamento" class="form-control">
                                        <option value="">-</option>
                                        <option value="size_crescente">Dimensione crescente</option>
                                        <option value="size_decrescente">Dimensione decrescente</option>
                                        <option value="time_crescente">Pi&ugrave; recente</option>
                                        <option value="time_decrescente">Meno recente</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-3 col-sm-12 mb-2 d-flex flex-column-reverse pb-3">
                                <div class="custom-control custom-checkbox cus-checkbox mr-3">
                                    <input type="checkbox" class="custom-control-input" id="archivio_inviati" name="archivio_inviati" [(ngModel)]="filter.inviati">
                                    <label class="custom-control-label" for="archivio_inviati">Inviati</label>
                                </div>
                            </div>
                            <div class="col-md-3 col-sm-12 mb-2 d-flex flex-column-reverse pb-3">
                                <div class="custom-control custom-checkbox cus-checkbox mr-3">
                                    <input type="checkbox" class="custom-control-input" id="archivio_ricevuti" name="archivio_ricevuti" [(ngModel)]="filter.ricevuti">
                                    <label class="custom-control-label" for="archivio_ricevuti">Ricevuti</label>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-lg-3 col-md-4 col-sm-12 mb-2">
                                <div class="custom-control custom-checkbox cus-checkbox mr-3">
                                    <input type="checkbox" class="custom-control-input" id="archivio_show_clients" name="archivio_show_clients" [(ngModel)]="filter.show_clients">
                                    <label class="custom-control-label" for="archivio_show_clients">Clienti</label>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-12 mb-2">
                                <div class="custom-control custom-checkbox cus-checkbox mr-3">
                                    <input type="checkbox" class="custom-control-input" id="archivio_show_workers" name="archivio_show_workers" [(ngModel)]="filter.show_workers">
                                    <label class="custom-control-label" for="archivio_show_workers">Dipendenti</label>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-12 mb-2">
                                <div class="custom-control custom-checkbox cus-checkbox mr-3">
                                    <input type="checkbox" class="custom-control-input" id="archivio_show_mine" name="archivio_show_mine" [(ngModel)]="filter.show_mine">
                                    <label class="custom-control-label" for="archivio_show_mine">Miei</label>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-lg-3 col-md-4 col-sm-12 mb-2">
                                <div class="custom-control custom-checkbox cus-checkbox mr-3">
                                    <input type="checkbox" class="custom-control-input" id="archivio_chat" name="archivio_chat" [(ngModel)]="filter.messaggio">
                                    <label class="custom-control-label" for="archivio_chat">Chat</label>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-12 mb-2">
                                <div class="custom-control custom-checkbox cus-checkbox mr-3">
                                    <input type="checkbox" class="custom-control-input" id="archivio_avviso" name="archivio_avviso" [(ngModel)]="filter.avviso">
                                    <label class="custom-control-label" for="archivio_avviso">Comunicazione</label>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-12 mb-2">
                                <div class="custom-control custom-checkbox cus-checkbox mr-3">
                                    <input type="checkbox" class="custom-control-input" id="archivio_altro" name="archivio_altro" [(ngModel)]="filter.altro">
                                    <label class="custom-control-label" for="archivio_altro">Archivio</label>
                                </div>
                            </div>
                        </div>
                        <div class="row"><div class="col-12"><hr></div></div>
                        <div class="row mb-3">
                            <div class="col-lg-3 col-md-4 col-sm-12 mb-2" *ngFor="let item of window.flowup.utils.collectionFileType | keyvalue; let i = index;">
                                <div class="custom-control custom-checkbox cus-checkbox mr-3">
                                    <input type="checkbox" class="custom-control-input" [id]="'archivio_altro_' + item.key" [name]="'archivio_altro_' + item.key" [(ngModel)]="filter[item.key]">
                                    <label class="custom-control-label" [for]="'archivio_altro_' + item.key">{{ item.value.label }}</label>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col">
                                <button type="button" class="btn btn-primary float-right" (click)="resetFilter()">Resetta filtri</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row clearfix file_manager mt-5">
        <div class="col-lg-3 col-md-4 col-sm-12" *ngFor="let document of archivio; let i = index;">
            <div class="card">
                <div class="file">
                    <a href="javascript:void(0);">
                        <div class="hover" (click)="handleModal(document.name, 'delete')" [hidden]="document.type != 'archivio'">
                            <button type="button" class="btn btn-sm btn-icon btn-danger">
                                <img width="25" height="25" src="assets/img/delete.png" alt="">
                            </button>
                        </div>
                        <div class="icon" (click)="openDocument(document)">
                            <img width="100" height="100" [src]="'assets/img/doctype/' + window.flowup.utils.getFileIcon(window.flowup.utils.getFileType(document.filename)) + '.png'" alt="">
                        </div>
                        <div class="file-name" (click)="openDocument(document)">
                            <p class="m-b-5 text-muted text-truncate">{{ document.display_name }}</p>
                            <small>Size: {{ window.flowup.utils.humanFileSize(document.size) }} <span class="date text-muted">{{ window.flowup.utils.getDateTime(document.upload_timestamp) }}</span></small>
                        </div>
                    </a>
                </div>
            </div>
        </div>

        <div class="unexpanded-card col-3" style="margin-bottom: 15px;" *ngIf="!archivio.length">
            <p>Nessun dato presente</p>
        </div>
    </div>
</div>

<span id="documentModal">
    <div class="modal-backdrop fade show" style="display: none;"></div>
    <div class="modal" style="overflow-y: scroll;" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ queryparams()['type'] == 'create' ? "Aggiungi documento" : "Documento" }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="handleModal(undefined, undefined)">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">

                    <form>
                        <div class="form-row">
                            <div class="form-group col-sm-12">
                                <label for="type">Seleziona il cliente per cui caricare il documento</label>
                                <select name="client_select" id="client_select" class="form-control" [(ngModel)]="getDocument().target">
                                    <option value="">-</option>
                                    <option [value]="window.usher.getPublicToken()">{{ window.usher.getPublicConfiguration()?.nome }}</option>
                                    <option [value]="user.public_token" *ngFor="let user of getUsers(undefined, 'cliente'); index as i">{{ user.public_configuration?.nome }}</option>
                                </select>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="form-group col-sm-12">
                                <label for="repository_documents" class="cursor-pointer">Inserisci il documento <i class="fa fa-plus ml-2"></i></label>
                                <input type="file" multiple id="repository_documents" hidden name="repository_documents" (change)="getDocuments($event)">
                            </div>
                        </div>
                    </form>

                    <div class="row clearfix file_manager mt-5">
                        <div class="col-lg-3 col-md-4 col-sm-12" *ngFor="let document of temp_documents; let i = index;">
                            <div class="card">
                                <div class="file">
                                    <a href="javascript:void(0);">
                                        <div class="hover" (click)="deleteTempDoc(i)">
                                            <button type="button" class="btn btn-sm btn-icon btn-danger">
                                                <img width="25" height="25" src="assets/img/delete.png" alt="">
                                            </button>
                                        </div>
                                        <div class="icon" (click)="openDocument(document)">
                                            <img width="100" height="100" [src]="'assets/img/doctype/' + window.flowup.utils.getFileIcon(window.flowup.utils.getFileType(document.filename)) + '.png'" alt="">
                                        </div>
                                        <div class="file-name" (click)="openDocument(document)">
                                            <p class="m-b-5 text-muted text-truncate">{{ document.display_name }}</p>
                                            <small>Size: {{ window.flowup.utils.humanFileSize(document.size) }} <span class="date text-muted">{{ window.flowup.utils.getDateTime(document.upload_timestamp) }}</span></small>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" (click)="handleDocument()">{{ queryparams()['type'] == 'create' ? "Aggiungi" : queryparams()['type'] == 'update' ? "Aggiorna" : ""}}</button>
                    <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="handleModal(undefined, undefined)">Chiudi</button>
                </div>
            </div>
        </div>
    </div>
</span>

<span id="deleteDocumentModal">
    <div class="modal-backdrop fade show" style="display: none;"></div>
    <div class="modal" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-md" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Conferma</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="handleModal(undefined, undefined)">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-row mb-4">
                        <div class="col-12">
                            <p>Sei sicuro di voler eliminare questo documento?</p>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger" (click)="deleteDocument()">Elimina</button>
                    <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="handleModal(undefined, undefined)">Chiudi</button>
                </div>
            </div>
        </div>
    </div>
</span>